export const MuiIconButton = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      '&:hover, &:active': {
        background: 'none',

        '.MuiSvgIcon-root, svg': {
          color: 'rgba(34, 40, 34, 1)',
          fill: 'rgba(34, 40, 34, 1)',
        },

        '&.MuiIconButton-colorSecondary .MuiSvgIcon-root': {
          color: 'rgba(30, 237, 159, 1)',
          fill: 'rgba(30, 237, 159, 1)',
        },
      },

      '.MuiSvgIcon-root, svg': {
        color: 'rgba(159, 159, 159, 1)',
        fill: 'rgba(159, 159, 159, 1)',
      },

      '&.MuiIconButton-colorSecondary .MuiSvgIcon-root': {
        color: 'rgba(255, 255, 255, 1)',
        fill: 'rgba(255, 255, 255, 1)',
      },
    },
    sizeMedium: {
      height: '24px',
      width: '24px',
    },
    sizeLarge: {
      height: '40px',
      width: '40px',
    },
  },
};
